import { DS_URL, EDITOR_URL_BACKEND, IS_PRODUCTION, MYCIRCLE_UPLOAD_URL, MYCIRCLE_URL, SALE_URL } from "Constants/Config"

let isProduction = IS_PRODUCTION

// isProduction = true
const serverUrlMain = `${EDITOR_URL_BACKEND}backds/`
const serverUrl = isProduction ? `${serverUrlMain}api/` : `${serverUrlMain}api/`
// const serverUrl = isProduction ? "https://signage.mycircle.net" : "https://neweditor.tjcg.in/backds/api/"

const imageUrl = DS_URL.replace("/api/", "") //IS_PRODUCTION ? "https://signage.mycircle.net" : "https://react.tjcg.in"

const mycircleUrl = MYCIRCLE_URL + "/" // isProduction ? "https://mycircle.net/" : "https://menspal.com/"
const salesUrl = SALE_URL + "/" // isProduction ? "https://sales.mycircle.net/" : "https://sales.menspal.com/"
const mycircleUrlApi = mycircleUrl + "api/ds/"

export const BASE_SERVER = serverUrl;
export const FE_SERVER = imageUrl;
export const JSON_SERVER_PATH = `${serverUrlMain}preview/`;

const UrlHelper = {
  templateImageUrl: `${imageUrl}/preview/templates/`,
  magicTemplateImageUrl: `${serverUrlMain}/preview/magic/`,
  newTemplateImageUrl: `${serverUrlMain}preview/templates/`,
  photosUrl: `${imageUrl}/preview/photos/thumbnails/`,
  thumbUrl: `${JSON_SERVER_PATH}thumb/`,
  mediaUrl: MYCIRCLE_UPLOAD_URL,
  // mediaUrl: isProduction ? `${serverUrl}media/image?path=` : MYCIRCLE_UPLOAD_URL,
  awsFolderName: isProduction ? 'mycircle-user-media/' : 'test-user-media/',

  // user apis
  signInWithDs: 'user/verifyUserData/',
  hasAddedCheque: salesUrl + 'api/hasAddedCheque',
  isFreePlan: salesUrl + 'api/isFreePlan',
  updateUserCredit: salesUrl + 'api/updateUserCredit',
  getCustomerCreditDetails: salesUrl + 'api/getCustomerCreditDetails',
  userInquiry: salesUrl + 'api/userInquiry',
  verifyDesignUserData:'user/verifyDesignUserData',

  // category apis
  getCategories: 'category/getCategories',
  getSubCategories: 'subCategory/getSubCategorys',

  // template apis
  addTemplate: 'freetemplate/addTemplate',
  editTemplate: 'freetemplate/editTemplate',
  getTemplates: 'freetemplate/getTemplateData',
  getTemplateById: 'freetemplate/getTemplateById',
  getMainTemplateById: 'template/getTemplateById',
  createUserMedia: 'media/createUserMedia',
  templatePublish: imageUrl + '/api/template-live-neweditor',
  wallTemplatePublish: imageUrl + '/api/wall/layout-live',

  // magic template apis
  addMagicTemplate: 'magic/addTemplate',
  editMagicTemplate: 'magic/editTemplate',
  getMagicTemplates: 'magic/getTemplates',
  getMagicTemplateById: 'magic/getTemplateById',

  // media apis
  createMedia: 'media/createMedia',
  autoSaveMedia: 'media/autoSaveMedia',
  saveMedia: 'media/saveMedia',
  getCanvasMedia: 'media/getCanvasMedia',
  getMedia: 'media/getMedia',
  deleteSlider: 'media/deleteSlider',
  addMedia: 'media/addMedia',
  deleteUserMedia: imageUrl + '/api/user/media/unauth/multidelete',
  deleteMediaById: 'media/deleteMedia/',
  copyMediaByUrl: 'media/copyMediaUrl',
  base64MediaToUrl: "media/base64MediaToUrl",

  // screen list
  getScreen: 'player/getPlayer',
  addScreen: 'player/addPlayer',

  // generateUploadImageText
  addRecentUsedData: 'recentUsed/addRecentUsedData',
  getRecentUsedData: 'recentUsed/getRecentUsedData',
  generateUploadImageText: 'recentUsed/generateUploadImageText',
  generateUrlImageText: 'recentUsed/generateUrlImageText',

  //Gebarate videLink
  generateVideoLink: `video-generate-neweditor`,

  // rss apis
  getRss: 'rss/getRss',
  convertRss: 'rss/convertRss',

  // TV Channels apis
  getTVChannels: 'tvChannel/getTVChannels',

  // mycircle apis
  getLocationList: mycircleUrlApi + 'getLocationList',
  createSwitchPlateFormToken: MYCIRCLE_URL + "/api/sales/createSwitchPlateFormToken",
  getMenuList: mycircleUrlApi + 'getMenuList',
  getMenuCategotyProductList: mycircleUrlApi + 'getMenuCategotyProductList',
  getQrDropdown: mycircleUrlApi + "getQrDropdown",

  // third party apis
  getPixabayImages: 'thirdPart/getPixabayImages',
  getPhoto: 'photos/getPhoto',
  getVideoCollection: 'thirdPart/getVideoCollection',
  generateAIGImage: 'thirdPart/aiImageGenerations',
  uploadYoutubeShort: 'thirdPart/youtube/upload/short',
  removeBackgroundImage: "photos/removeBackgroundImage",
  generateBase64ImageText: "photos/generateBase64ImageText",

  // brand apis
  addBrand: 'brand/addBrand',
  editBrand: 'brand/editBrand',
  getBrandById: 'brand/getBrandById/',
  getBrands: 'brand/getBrands',
  deleteBrand: 'brand/deleteBrand/',

  recordTemplateVideo: 'template/recordWebsite',

  // magic create apis
  getMagicTemplate: 'magic/getTemplates',
  getRandomTemplate: 'magic/getRandomTemplate',
  getSearchTemplate: 'magic/getSearchTemplate',
  getSearchMenu: 'magic/getSearchMenu',

  // log apis
  autosaveLog: 'neweditor/autosaveLog',
  getLogs: 'neweditor/getLogs',
  getLogById: 'neweditor/getLogById',

  // web-app
  getSubCategoriesWebApp: DS_URL + "webapp/getSubCategory",
  getTemplatesWebApp: DS_URL + "webapp/getTemplateData",
  getTemplatesWebPublishApp: DS_URL + "webapp/template-live-webapp",
  getUserPlaylist: DS_URL + "playlists",
  getUserPlaylistPublish: DS_URL + "playlist-live",
  getUserLayoutPublish: DS_URL + "layout-live",
  getUserLayout: DS_URL + "getlayout",
  getUserMedia: DS_URL + "user/getMediaData",
  updatePlayerApi: DS_URL + "/player-screen-update",
  getPlayerDetails: DS_URL + "/players/",

  // designer
  changeStatus: 'designer/neweditor/changeStatus'
  
}

export default UrlHelper